import { render, staticRenderFns } from "./NotificationDropdownCustom.vue?vue&type=template&id=4b832df9&scoped=true&"
import script from "./NotificationDropdownCustom.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdownCustom.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropdownCustom.vue?vue&type=style&index=0&id=4b832df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b832df9",
  null
  
)

export default component.exports